import { render, staticRenderFns } from "./ArboCollections.vue?vue&type=template&id=d580e5ac&scoped=true&"
import script from "./ArboCollections.vue?vue&type=script&lang=js&"
export * from "./ArboCollections.vue?vue&type=script&lang=js&"
import style0 from "./ArboCollections.vue?vue&type=style&index=0&id=d580e5ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d580e5ac",
  null
  
)

export default component.exports